import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { groupsApi } from "@/api/groups";

/** Store for training page language filter. Restricts topbar LanguageSwitcher to event/group languages when in a scenario. */
interface TrainingLanguageState {
  /** null = no filter (all languages). string[] = only these locale codes allowed. */
  allowedLocaleCodes: string[] | null;
  setEventLanguages: (groupId: number) => Promise<void>;
  clearFilter: () => void;
}

export const useTrainingLanguageStore = create<TrainingLanguageState>()(
  devtools(
    (set) => ({
      allowedLocaleCodes: null,

      /** Fetch group languages (same usage as AssignLanguageSection / groups edit page). */
      setEventLanguages: async (groupId: number) => {
        try {
          const response = await groupsApi.getLanguages(groupId);
          let codes: string[] = [];
          if (Array.isArray(response.data)) {
            codes = response.data;
          } else if (response.data && typeof response.data === "object") {
            const obj = response.data as { allowed_languages?: string[] | null };
            codes = Array.isArray(obj.allowed_languages)
              ? obj.allowed_languages
              : [];
          }
          set({ allowedLocaleCodes: codes });
        } catch {
          set({ allowedLocaleCodes: [] });
        }
      },

      /** Clear filter so switcher shows all languages again. */
      clearFilter: () => set({ allowedLocaleCodes: null }),
    }),
    { name: "TrainingLanguageStore" },
  ),
);
